import React, { ComponentType } from 'react'
import { Container } from '@shared/components/container'
import { Tabs } from '@shared/components/tabs'
import { TabsData } from '@shared/components/tabs/model'

import { useNodeParams } from '../../hooks/useNodeParams'
import { AvailableComponentTypes, PageNodeViewModel } from '../../types'

import styles from './style.module.scss'

interface Props {
	node: PageNodeViewModel
	Node: ComponentType<any>
}

export const NodeTabs = ({ node, Node }: Props) => {
	const nodeParams = useNodeParams(node.value.nodeParam)
	const tabs: TabsData[] = nodeParams
		.get(AvailableComponentTypes.stringArray, '')
		.split('\n')
		.map((title, index) => {
			const tabNode = (node.children || [])[index]
			return {
				tabTitle: title,
				TabComponent: function TabComponentWrapper() {
					return <>{tabNode ? <Node nodeViewModel={tabNode} /> : null}</>
				},
			} as TabsData
		})

	return (
		<Container className={styles.wrapper}>
			<Tabs data={tabs} />
		</Container>
	)
}
